import { useHttpHeaders } from "@ice/react";
import { APP_VERSION, BASE_APP_NAME } from "../../../config";

interface Params {
    method?: RequestInit["method"];
}

export const useHttpGovernmentAgencyHubAppHeaders = ({
    method,
}: Params = {}) => {
    const headers = useHttpHeaders({
        appName: BASE_APP_NAME,
        appVersion: APP_VERSION,
    });

    switch (method) {
        case "POST":
        case "PUT":
        case "PATCH": {
            return { ...headers, "content-type": "application/json" };
        }
        default: {
            return headers;
        }
    }
};
